import { washNesTabOne } from '@/utils/wash.js'
export const washData = (node) => {
  washNesTabOne(node)
}
